import React from "react";
import { useShoppingContext } from "../../../../context/ShoppingContext";
import AddAveForm from "../../Forms/AddBatchForm/AddAveForm";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";

const AddBatch = () => {
  const { setShowAddAves, showAddAves} = useShoppingContext();
  return (
    <div className="text-center">
      <button
        className={" w-100 btn btn-green"}
        onClick={() => {setShowAddAves(!showAddAves)} }
      >
        <FontAwesomeIcon icon={faPlus} />{" "}
        Aves
      </button>
      {showAddAves && <AddAveForm />}
    </div>
  );
};

export default AddBatch;
